import { type FC } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { Shipping } from '@interfaces/models/shipping';
import AddToCartModal from '@components/molecules/products/add-to-cart-modal/add-to-cart-modal';
import { NegotiationModalInprogress } from '@components/organisms/negotiation/negotiation-modal/inprogress/negotiation-modal-inprogress';
import { NegotiationModalNew } from '@components/organisms/negotiation/negotiation-modal/new/negotiation-modal-new';
import { useNegotiationModalPresenter } from '@components/organisms/negotiation/negotiation-modal/negotiation-modal-presenter';
import NegotitationListingsModalSkeleton from '@components/organisms/catalog/components/skeleton-components/negotiation-modal-skeleton/negotiation-listings-modal-skeleton';
import styles from './negotiation-modal.module.scss';

interface NegotiationModalProps {
  trackingFrom: string;
  shippingInfo?: Shipping;
  onClose?: () => void;
  buyerId?: string;
  showFpdSection?: boolean;
  showCheckoutModal?: boolean;
  isNegotiationLoading?: boolean;
  modalDialogTitleId?: string;
}

export const NegotiationModal: FC<NegotiationModalProps> = ({
  shippingInfo,
  trackingFrom,
  buyerId,
  showFpdSection,
  showCheckoutModal,
  isNegotiationLoading,
  onClose,
  modalDialogTitleId,
}) => {
  const { t } = useTranslation();
  const { negotiation, initialData, negotiationProduct, isLoading, setIsLoading } = useNegotiationModalPresenter();

  return (
    <>
      <h2
        className={clsx('vc-modal__title', styles.mmao__popin__title)}
        id={modalDialogTitleId}
      >
        {t('MMAO.POPIN.TITLE')}
      </h2>
      <div className={clsx(styles.mmao, { hasLoader: isLoading })}>
        {isNegotiationLoading ? (
          <NegotitationListingsModalSkeleton />
        ) : negotiation ? (
          <NegotiationModalInprogress
            isShippingProhibited={shippingInfo?.prohibited}
            trackingFrom={trackingFrom}
            onClose={onClose}
            showFpdSection={showFpdSection}
          />
        ) : initialData ? (
          <NegotiationModalNew
            isShippingProhibited={shippingInfo?.prohibited}
            trackingFrom={trackingFrom}
            buyerId={buyerId}
            setIsLoading={setIsLoading}
            onClose={onClose}
            productPath={negotiationProduct?.path}
          />
        ) : null}
      </div>
      <AddToCartModal
        showCheckoutModal={showCheckoutModal}
        onCloseDialog={() => {
          setIsLoading(false);
        }}
      />
    </>
  );
};
